module.exports = __webpack_public_path__ + "static/img/sc03.a17740c8.png";